<template>
  <div class="notifications" v-if="notifications.length > 0">
    <div
      v-for="notification in notifications"
      :class="`notification ${notification.state}`"
      :key="notification.id"
    >
      <p v-html="notification.message"></p>
      <template v-if="notification.button">
        <Button
          :icon="notification.button.icon"
          :class="notification.button.class"
          @click="notification.button.func ? notification.button.func() : null"
        >{{ notification.button.text }}</Button>
      </template>
      <Button v-if="notification.clearable" class="small-white" @click="$store.commit('Notifications/clearOne', notification.id)">Hide</Button>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    /**
     * Get all notifications that has top-bar type
     * @returns {Array}
     */
    notifications() {
      return this.$store.getters['Notifications/get']('top-bar');
    },
  },
};
</script>

<style lang="scss" scoped>
.notifications {
  position: sticky;
  top: 0;
  z-index: 3;
  width: 100%;

  @media (max-width: 1023px) {
    top: var(--sidebar-height);
  }
}

.notification {
  align-items: center;
  display: flex;
  justify-content: center;
  background-color: #FFF3CB;
  box-shadow: 0 1px 0 0 #E8D4BE;
  padding: 6px 15px;
  flex-wrap: wrap;
  position: relative;

  &:not(:only-child) {
    &:not(:last-child) {
      border-bottom: 1px solid #f2e2d2;
    }
  }

  & > * {
    &:not(:last-child) {
      margin-right: 12px;
    }
  }

  p {
    color: black;
    font-size: 14px;
    font-weight: 500;
    line-height: 24px;
    text-align: center;
  }

  &.warning, &.fatal {
    background: #F73131;
    box-shadow: 0 1px 0 0 #DB1B1B;

    p {
      color: white;
    }
  }

  &.pending {
    background: #ADB5BC;
    box-shadow: 0 1px 0 0 #9fa5aa;
    p {
      color: white;
    }
  }
  
}
</style>
